import { IconFeatureCard } from '@/components';
import { ICON_FEATURE_CARDS_QUERYResult } from 'sanity.types';

type FeatureCardItem = NonNullable<ICON_FEATURE_CARDS_QUERYResult>[number];
interface IconFeatureCardBlockProps {
    iconFeatureCards: ICON_FEATURE_CARDS_QUERYResult;
}

const IconFeatureCardBlock = ({
    iconFeatureCards,
}: IconFeatureCardBlockProps) => {
    const sortedCards = [...(iconFeatureCards ?? [])].sort((a, b) => {
        const orderA = a.order ?? 0;
        const orderB = b.order ?? 0;
        return orderA - orderB;
    });

    if (sortedCards.length === 0) return null;

    return (
        <div className="flex gap-4 flex-col md:flex-row md:gap-12 md:flex-nowrap p-4">
            {sortedCards.map((featureCard: FeatureCardItem, idx: number) => (
                <div className="flex w-full md:w-1/3" key={idx}>
                    <IconFeatureCard
                        title={featureCard.title ?? ''}
                        copy={featureCard.copy ?? ''}
                    />
                </div>
            ))}
        </div>
    );
};

export default IconFeatureCardBlock;
